import icons from "../../../../../Data/icons";
import classes from "./addRule.module.css";

const AddRule = ({
  name,
  description,
  type,
  active,
  durationType,
  valueType,
  defaultDuration,
  defaultValue,
  slug,  
  default_process_type,
  setName,
  setDescription,
  setType,
  setActive,
  setDurationType,
  setValueType,
  setSlug,
  setDefaultDuration,
  setDefaultValue,
  setDefaultProcessType,
}) => {
  const City = icons.City;
  const RulesIcon = icons.rules;
  const AbcIcon = icons.abc
  const TypeIcon = icons.type
  const DurationIcon =icons.duration
  const ValueIcon = icons.value
  const types = [
    "checkin",
    "checkout",
    "absence",
    "overtime",
    "break",
    "fixable",
  ];

  const valueTypes = ["increase", "decrease"];
  const durationTypes = ["time", "number"];
  const defaultProcessType = ["days", "amount"];
  
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };
  const handleActiveChange = (e) => {
    const isChecked = e.target.checked;
    setActive(isChecked ? 1 : 0);
  };
  const handleTypeChange = (e) => {
    setType(e.target.value);
  };
  const handleValueTypeChange = (e) => {
    setValueType(e.target.value);
  };
  const handleDurationTypeChange = (e) => {
    setDurationType(e.target.value);
  };
  const handleSlugChange = (e) => {
    setSlug(e.target.value);
  };
  const handleDefaultDurationChange = (e) => {
    setDefaultDuration(e.target.value);
  };
  const handleDefaultValueChange = (e) => {
    const value = parseFloat(e.target.value).toFixed(3);
    setDefaultValue(value);
  };
  const handleDefaultProcessType = (e) => {
    const { value } = e.target;
    setDefaultProcessType(value);
  };

  return (
    <div className="row">
      <div className="col-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="name">الاسم</label>
              <div className={classes.iconInput}>
                <AbcIcon />
              </div>
              <input
                id="name"
                type="text"
                value={name}
                placeholder="ادخل الاسم"
                onChange={handleNameChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="slug">الاسم المستعار</label>
              <div className={classes.iconInput}>
                <AbcIcon />
              </div>
              <input
                id="slug"
                type="text"
                value={slug}
                placeholder="ادخل الاسم المستعار"
                onChange={handleSlugChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="description">الوصف</label>
              <div className={classes.iconInput}>
                <AbcIcon />
              </div>
              <textarea
                id="description"
                placeholder="الوصف"
                value={description}
                onChange={handleDescriptionChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="type">النوع</label>
              <div className={classes.iconInput}>
                <TypeIcon />
              </div>
              <select
                id="type"
                onChange={handleTypeChange}
                value={type}
                className={classes.inputCustom}>
                <option value="">اختار النوع</option>
                {types.map((type, i) => (
                  <option key={i} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div className={classes.formCol}>
              <label htmlFor="valueType">نوع القيمة</label>
              <div className={classes.iconInput}>
                <TypeIcon />
              </div>
              <select
                id="valueType"
                onChange={handleValueTypeChange}
                className={classes.inputCustom}
                value={valueType}>
                <option value="">اختار نوع القيمة</option>
                {valueTypes.map((valueType, i) => (
                  <option key={i} value={valueType}>
                    {valueType}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className="col-6">
        <div className={classes.formCard}>
          <div className={classes.formGrid}>
            <div className={classes.formCol}>
              <label htmlFor="processType">نوع العملية الافتراضية</label>
              <div className={classes.iconInput}>
                <TypeIcon />
              </div>
              <select
                value={default_process_type}
                onChange={handleDefaultProcessType}
                className={classes.inputCustom}>
                <option value="">اختار نوع العملية</option>
                {defaultProcessType.map((processType, i) => (
                  <option key={i} value={processType}>
                    {processType}
                  </option>
                ))}
              </select>
            </div>
            <div className={classes.formCol}>
              <label htmlFor="durationType">نوع المدة</label>
              <div className={classes.iconInput}>
                <DurationIcon />
              </div>
              <select
                id="durationType"
                onChange={handleDurationTypeChange}
                value={durationType}
                className={classes.inputCustom}>
                <option value="">اختار نوع المدة</option>

                {durationTypes.map((durationType, i) => (
                  <option key={i} value={durationType}>
                    {" "}
                    {durationType}
                  </option>
                ))}
              </select>
            </div>

            <div className={classes.formCol}>
              <label htmlFor="defaultDuration">المدة الافتراضية</label>
               <div className={classes.iconInput}>
                <DurationIcon />
              </div>
              <input
                id="defaultDuration"
                type="text"
                value={defaultDuration}
                placeholder="ادخل المدة الافتراضية"
                onChange={handleDefaultDurationChange}
                className={classes.inputCustom}
              />
            </div>
            <div className={classes.formCol}>
              <label htmlFor="defaultValue">القيمة الافتراضية</label>
              <div className={classes.iconInput}>
                <ValueIcon />
              </div>
              <input
                id="defaultValue"
                type="number"
                value={defaultValue}
                placeholder="ادخل القيمة الافتراضية"
                onChange={handleDefaultValueChange}
                className={classes.inputCustom}
              />
            </div>

            <div className={classes.formCol}>
              <label
                htmlFor=""
                className={
                  active ? `${classes.active}` : `${classes.disActive}`
                }>
                {" "}
                {active == 1 ? " نشط" : "غير نشط"}{" "}
              </label>

              <label class="switch">
                <input
                  type="checkbox"
                  onChange={handleActiveChange}
                  checked={active}
                />
                <span class="slider round"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddRule;
